import { withBox, flexStyles, makeStyles } from "@mujo/box";

export const sizes = {
  xs: 4,
  s: 8,
  m: 16,
  l: 24
};

export const colors = {
  background: "#e3e2ec",
  scribbles: "#ffcc99",
  foreground: "#222",
  highlight: "#c77e35"
};

export const Box = withBox({
  styleGuide: {
    ...flexStyles,

    color: makeStyles("color", colors),
    backgroundColor: makeStyles("backgroundColor", colors),

    padding: makeStyles("padding", sizes),
    paddingLeft: makeStyles("paddingLeft", sizes),
    paddingRight: makeStyles("paddingRight", sizes),
    paddingTop: makeStyles("paddingTop", sizes),
    paddingBottom: makeStyles("paddingBottom", sizes),
    borderRadius: makeStyles("borderRadius", sizes),

    font: {
      display: {
        marginTop: 0,
        marginBottom: 0,
        fontSize: "3em",
        lineHeight: "1em",
        paddingBottom: 24,
        paddingTop: 24
      },
      header: {
        marginTop: 0,
        marginBottom: 0,
        fontSize: "2em",
        lineHeight: "1em",
        paddingBottom: 8,
        paddingTop: 8
      },
      subHeader: {
        marginTop: 0,
        marginBottom: 0,
        fontSize: "1.5em",
        lineHeight: "1em",
        paddingBottom: 8,
        paddingTop: 8
      },
      paragraph: {
        marginTop: 0,
        marginBottom: 0,
        fontSize: "1em",
        lineHeight: "1.3em",
        paddingBottom: 8,
        paddingTop: 8
      }
    }
  },
  defaultComponent: "div"
});
